mutation UnpublishVariationsXmlFeed(
    $campaignId: ID!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $publishProvider: String!
) {
    unpublishVariationsXmlFeed(
        campaignId: $campaignId
        publishProvider: $publishProvider
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
    )
}
